import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

import { SosAlert } from '../../sos-alert.model'

@Component({
  selector: 'lin-sos-alert',
  templateUrl: './sos-alert.component.html',
  styleUrls: ['./sos-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SosAlertComponent {
  @Input() alert: SosAlert
  @Input() isClient = false

  @Output() acknowledge = new EventEmitter<void>()
  @Output() viewOnMap = new EventEmitter<void>()

  get initials(): string {
    const name = this.alert?.driver?.trim() || 'SOS'
    return name
      .split(/\s+/)
      .map((part) => part[0])
      .slice(0, 2)
      .join('')
      .toUpperCase()
  }
}
